import {RegressionState} from 'ui-library/charting/statistics/regression/RegressionTypes';

import {IdDataRow, MaskingBlockViewState} from './block-view-state/useMaskedBlockViewState';
import {BlockViewState} from './reduceBlockViewStates';

export enum InsightsBlockViewStateActionType {
  INSIGHTS_UPDATE_ALL_BLOCK_VIEW_STATES_FOR_BLOCK = 'INSIGHTS_UPDATE_ALL_BLOCK_VIEW_STATES_FOR_BLOCK',
  INSIGHTS_UPDATE_BLOCK_VIEW_STATE = 'INSIGHTS_UPDATE_BLOCK_VIEW_STATE',
}

interface InsightsUpdateAllBlockViewStatesForBlockAction {
  type: InsightsBlockViewStateActionType.INSIGHTS_UPDATE_ALL_BLOCK_VIEW_STATES_FOR_BLOCK;
  analyticsQueryId: string;
  blockViewStateUpdate: Partial<BlockViewState>;
}

export function updateAllBlockViewStatesForBlock(
  analyticsQueryId: string,
  blockViewStateUpdate: Partial<BlockViewState>
): InsightsUpdateAllBlockViewStatesForBlockAction {
  return {
    type: InsightsBlockViewStateActionType.INSIGHTS_UPDATE_ALL_BLOCK_VIEW_STATES_FOR_BLOCK,
    analyticsQueryId,
    blockViewStateUpdate,
  };
}

interface InsightsUpdateBlockViewStateAction {
  type: InsightsBlockViewStateActionType.INSIGHTS_UPDATE_BLOCK_VIEW_STATE;
  blockViewStateId: string;
  blockViewStateUpdate: Partial<BlockViewState>;
}

export function updateBlockViewState(
  blockViewStateId: string,
  blockViewStateUpdate: Partial<BlockViewState>
): InsightsUpdateBlockViewStateAction {
  return {
    type: InsightsBlockViewStateActionType.INSIGHTS_UPDATE_BLOCK_VIEW_STATE,
    blockViewStateId,
    blockViewStateUpdate,
  };
}

export function updateAllRegressionStatesForBlock(
  analyticsQueryId: string,
  regressionState: RegressionState | null
): InsightsUpdateAllBlockViewStatesForBlockAction {
  return updateAllBlockViewStatesForBlock(analyticsQueryId, {regressionState});
}

export function updateBlockRegressionState(
  blockViewStateId: string,
  regressionState: RegressionState | null
): InsightsUpdateBlockViewStateAction {
  return updateBlockViewState(blockViewStateId, {regressionState});
}

export function updateBlockMaskingState(
  blockViewStateId: string,
  maskingState: MaskingBlockViewState<IdDataRow> | null
): InsightsUpdateBlockViewStateAction {
  return updateBlockViewState(blockViewStateId, {maskingState});
}

export type InsightsBlockViewStateAction =
  | InsightsUpdateAllBlockViewStatesForBlockAction
  | InsightsUpdateBlockViewStateAction;
